import CryptoJS from 'crypto-js';
import { carrinhoSugestoes, carrinhoValidar, empresaCarregar } from './Services';
import { cartSchedule } from './cartItem';

export type CartSuggestion = {
  productId: string; name: string; price: number; image?: string;
  requiresConfiguration: boolean; priceFrom?: boolean;
};
export type CartValidation = {
  valid: boolean; produtos: any[]; changed: boolean;
  errors: { code: string; message: string; index?: number }[];
};

export function cartApiHeaders() {
  const key = 'fcc196694c444938b340251bf7771a2b';
  return { 'Content-Type': 'application/json', token: CryptoJS.HmacSHA256(key, key).toString(),
    versao: localStorage.getItem('versao') || '', marca: localStorage.getItem('marca') || '' };
}

export class CartValidationError extends Error {
  constructor(public result: CartValidation, message: string) { super(message); }
}

async function cartRequest(url: string, body: any, signal?: AbortSignal) {
  const response = await fetch(url, { method: 'POST', headers: cartApiHeaders(),
    credentials: 'include', body: JSON.stringify(body), signal });
  const result = await response.json();
  if (!response.ok) throw new CartValidationError(result,
    result.message || result.errors?.[0]?.message || 'Não foi possível validar o carrinho. Tente novamente.');
  return result;
}

export async function getCartSuggestions(empresaid: string, produtos: any[],
  agendamento: any, signal?: AbortSignal): Promise<CartSuggestion[]> {
  const result = await cartRequest(carrinhoSugestoes.url, { empresaid, produtos, agendamento }, signal);
  return (result.suggestions || []).slice(0, 3);
}

export async function validateCartItems(empresaid: string, produtos: any[],
  agendamento: any = cartSchedule()): Promise<CartValidation> {
  const result: CartValidation = await cartRequest(carrinhoValidar.url, { empresaid, produtos, agendamento });
  if (!result.valid) throw new CartValidationError(result,
    result.errors?.[0]?.message || 'Revise os itens do carrinho.');
  return result;
}

export async function loadCartCompany(empresaid: string) {
  const response = await fetch(empresaCarregar.url.replace('{id}', encodeURIComponent(empresaid)), {
    headers: cartApiHeaders(), credentials: 'include',
  });
  if (!response.ok) throw new Error('Não foi possível atualizar o catálogo. Tente novamente.');
  const result = await response.json();
  return result.Item;
}
